<template>
  <v-expansion-panel
    v-if="!isNew"
    @click="handleExpand"
  >
    <v-expansion-panel-header>{{ $t('booking.terms.title', locale)}}</v-expansion-panel-header>
    <v-expansion-panel-content
    >
      <v-checkbox
        v-model="requiredTermsActive"
        :label="$t('booking.terms.requiredTermsActive')"
        hide-details
        @change="handleChangeIsModified"
      />
      <v-checkbox
        v-show="requiredTermsActive"
        v-model="requiredTermsIsLink"
        label="Es URL"
        hide-details
        @change="handleChangeIsModified"
      />
      <translate
      :key="`term${requiredTermsIsLink}`"
        v-show="requiredTermsActive"
        style="margin-top: 10px;"
        v-model="requiredTerms"
        :languages="languages"
        :label="$t('booking.terms.requiredTerms', locale)"
        @input="handleChangeIsModified"
        :type="requiredTermsIsLink ? null : 'textArea'"
      />
      <v-divider/>
      <v-checkbox
        v-model="requiredPrivacyActive"
        :label="$t('booking.terms.requiredPrivacyActive')"
        hide-details
        @change="handleChangeIsModified"
      />
      <v-checkbox
        v-show="requiredPrivacyActive"
        v-model="requiredPrivacyIsLink"
        label="Es URL"
        hide-details
        @change="handleChangeIsModified"
      />
      <translate
        :key="`privacy${requiredPrivacyIsLink}`"
        v-show="requiredPrivacyActive"
        style="margin-top: 10px;"
        v-model="requiredPrivacy"
        :languages="languages"
        :label="$t('booking.terms.requiredPrivacy', locale)"
        @input="handleChangeIsModified"
        :type="requiredPrivacyIsLink ? null : 'textArea'"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import Translate from '@/components/Translate'
import api from '@/services/api'
//import utils from '@/services/utils'
export default {
  components: {
    Translate,
  },
  props: {
    locale: {
      type: String,
      default: null,
    },
    languages: {
      type: Array,
      required: true,
    },
    editedActivityID: {
      type: String,
      default: null,
    },
    onChange: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    requiredTermsActive: null,
    requiredTermsIsLink: null,
    requiredTerms: null,
    requiredPrivacyActive: null,
    requiredPrivacyIsLink: null,
    requiredPrivacy: null,
  }),
  computed: {
    isNew () {
      return this.editedActivityID === 'new'
    },
  },
  methods: {
    handleExpand () {
      if (this.editedActivityID && this.requiredTermsActive === null) this.handleGetData()
    },
    handleGetData () {
      this.loading = true
      api.getItem('booking', `v1/private/activities/`, `${this.editedActivityID}/terms`)
        .then(response => {
          if (!response) {
            this.requiredTermsActive = false
            this.requiredTermsIsLink = false
            this.requiredTerms = {
              es: ''
            }
            this.requiredPrivacyActive = false
            this.requiredPrivacyIsLink = false
            this.requiredPrivacy = {
              es: ''
            }
          } else {
            this.requiredTermsActive = response.RequiredTermsActive
            this.requiredTerms = response.RequiredTerms ? JSON.parse(response.RequiredTerms) : { es: '' }
            this.requiredTermsIsLink = response.RequiredTermsIsLink ? true : false
            this.requiredPrivacyActive = response.RequiredPrivacyActive
            this.requiredPrivacy = response.RequiredPrivacy ? JSON.parse(response.RequiredPrivacy) : { es: '' }
            this.requiredPrivacyIsLink = response.RequiredPrivacyIsLink ? true : false
          }
          this.loading = false
       })
    },
    handleChangeIsModified () {
      this.onChange({
        RequiredTermsActive: this.requiredTermsActive,
        RequiredTerms: this.requiredTerms,
        RequiredTermsIsLink: this.requiredTermsIsLink,
        RequiredPrivacyActive: this.requiredPrivacyActive,
        RequiredPrivacy: this.requiredPrivacy,
        RequiredPrivacyIsLink: this.requiredPrivacyIsLink,
      })
    },
  },
}
</script>

